import type { SxProps, Theme } from '@mui/material';

// Scalar AI Gradient Colors - Based on the Color System
export const AI_GRADIENT_COLORS = {
  indigo: '#4F55E7',
  amethyst: '#614CE9',
  violet: '#6E46EC',
  electricPurple: '#7344ED',
  mutedPurple: '#704FAE',
  magenta: '#D213DF',
  teal: '#00AEC6',
} as const;

// CSS linear-gradient string for use in background/border-image properties
export const AI_GRADIENT_CSS = `linear-gradient(90deg, ${AI_GRADIENT_COLORS.indigo}, ${AI_GRADIENT_COLORS.amethyst}, ${AI_GRADIENT_COLORS.violet}, ${AI_GRADIENT_COLORS.electricPurple}, ${AI_GRADIENT_COLORS.magenta}, ${AI_GRADIENT_COLORS.teal})`;

// MUI SX props for gradient text
export const aiGradientTextSx: SxProps<Theme> = {
  background: AI_GRADIENT_CSS,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

// SVG gradient stops for use in SVG <linearGradient> elements
export const AI_GRADIENT_STOPS = [
  { offset: '0%', color: AI_GRADIENT_COLORS.indigo },
  { offset: '20%', color: AI_GRADIENT_COLORS.amethyst },
  { offset: '40%', color: AI_GRADIENT_COLORS.violet },
  { offset: '60%', color: AI_GRADIENT_COLORS.electricPurple },
  { offset: '80%', color: AI_GRADIENT_COLORS.magenta },
  { offset: '100%', color: AI_GRADIENT_COLORS.teal },
] as const;
